
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatson",
      function () {
        return require("private-next-pages/whatson.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatson"])
      });
    }
  